import { ValueOfKey } from '../../utils-types';

export const CHALLENGE_PAYMENT_RESULT_TYPE = {
  FREE: 'FREE',
  WITH_PAYMENT: 'WITH_PAYMENT',
} as const;

export type ChallengePaymentResultType = ValueOfKey<typeof CHALLENGE_PAYMENT_RESULT_TYPE>;
